import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/nearby-experiences";
const TITLE = "Nearby Experiences — Grand Canyon, Sedona and so much more";
const OG_TITLE = "Nearby Experiences — Grand Canyon and more";
const DESC =
  "Explore beyond the property: — Day trip to the Grand Canyon or Sedona, Visit a majestic waterfall right around the corner. There is an adventure close by for everyone.";
const OG_IMAGE =
  "https://www.travelbackland.com/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/path-hero.jpg";

export const Route = createFileRoute("/nearby-experiences")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: OG_TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "TouristAttraction",
          name: "Nearby Experiences around Backland",
          url: URL,
          description: DESC,
        }),
      },
    ],
  }),
  component: NearbyRoute,
});

function NearbyRoute() {
  return <StoryExperience initialCategorySlug="nearby" />;
}
